{
  "public.detail": {
    "search.placeholder": "Wyszukaj shortlistę",
    "hero.shortlistBy": "Shortlista stworzona w {{name}}",
    "empty.title": "Nikt nie został dodany do shortlisty",
    "empty.description": "Zbuduj swoją shortlistę, wybierając zasoby do prezentacji dla zainteresowanych stron",
    "filters.label": "Filtry",
    "item.emptyValue": "n/d",
    "passwordProtection": {
      "enterPassword": "Wpisz hasło, aby zobaczyć shortlistę",
      "placeholder": "Wpisz hasło",
      "viewShortlist": "Zobacz shortlistę"
    },
    "error": {
      "title": "Błąd podczas wyszukiwania shortlisty"
    }
  },
  "GenericSearchFilterItem": {
    "filters": {
      "belongsToMe": "Należy do mnie",
      "createdAt": "Utworzono po {{date}}",
      "publishedOnly": "Tylko opublikowane",
      "draftOnly": "Tylko szkice",
      "archived": "Pokaż zarchiwizowane",
      "contactId": "Zasób {{contact}}",
      "between": "Pomiędzy {{startDate}} - {{endDate}}",
      "tags": {
        "and": " i ",
        "more": " więcej",
        "any": "Dowolny tag: {{tag}}",
        "match": "Pasujące tagi: {{tags}}"
      }
    }
  },
  "GridViewItemGallery": {
    "editGallery": "Edytuj galerię",
    "emptyGalleryTitle": "Pusta galeria",
    "emptyGalleryDescription": "Dodaj media dla tego zasobu",
    "addMedia": "Dodaj media"
  },
  "ShortlistVotes": {
    "upvote": "Głos za",
    "downvote": "Głos przeciw"
  },
  "ShortlistMediaSidebarPage": {
    "draft": "Szkic",
    "votingDisabled": "Głosowanie jest wyłączone, gdy lista nie jest opublikowana",
    "commentingDisabled": "Komentowanie jest wyłączone, gdy lista nie jest opublikowana",
    "votingAndCommentingDisabled": "Głosowanie i komentowanie są wyłączone, gdy lista nie jest opublikowana"
  },
  "MediaSidebar": {
    "Header": {
      "shortlistedCount": "{{count}} Z {{totalBlocks}} NA SHORTLIŚCIE"
    },
    "ResourceInfo": {
      "showDetails": "Szczegóły",
      "hideDetails": "Ukryj"
    },
    "CommentList": {
      "noComments": "Brak komentarzy",
      "startConversation": "Rozpocznij rozmowę o tej osobie z członkami zespołu"
    },
    "CommentInput": {
      "writeComment": "Napisz komentarz",
      "addComment": "Dodaj komentarz"
    },
    "GuestNameChangeForm": {
      "title": "Opinia gościa",
      "description": "Wpisz swoje imię poniżej, aby zostawić opinię",
      "placeholder": "Twoje imię",
      "saveChanges": "Zapisz zmiany"
    },
    "GuestInfo": {
      "youAre": "Jesteś {{name}}",
      "change": "Zmień"
    }
  },
  "SetGuestNameModal": {
    "title": "Ustaw nazwę gościa",
    "description": "Musisz powiedzieć właścicielowi shortlisty, kim jesteś, zanim będziesz mógł głosować lub komentować osoby na liście",
    "yourName": "Twoje imię",
    "saveName": "Zapisz nazwę",
    "successfullyCreated": "Pomyślnie utworzono",
    "guestNameSet": "Nazwa gościa ustawiona"
  }
}
